<span class="loader"
[style.--width1]=" (width/2)+ 'px'"
[style.--thickness]=" thickness+ 'px'"
[style.--primaryColor]="primaryColor "
[style.--secondaryColor]="secondaryColor ">Load&nbsp;ng</span>